module.exports = __webpack_public_path__ + "static/img/son5_active.a73e1ca2.png";